var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card-listagem", {
    attrs: {
      cardTitle: _vm.tituloCard,
      showBtnAction: _vm.showButtonCadastrar,
      btnType: _vm.typeActionButton,
      btnIconClass: _vm.iconActionButton,
      btnActionTitle: _vm.nameActionButton
    },
    on: {
      execAction: function($event) {
        return _vm.$emit("click")
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "body",
          fn: function() {
            return [
              _c(
                "div",
                [
                  _vm.hasHeader || _vm.hasRefreshButton
                    ? _c("app-divider-refresh-button", {
                        attrs: {
                          label: _vm.headerLabel,
                          hasButton: _vm.hasRefreshButton,
                          content: _vm.tooltipRefreshButton,
                          showBorder: false
                        },
                        on: { click: _vm.updateListagem }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [
                _vm.showBorder
                  ? _c("div", { staticClass: "divider" })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: { data: _vm.dataForTable },
                  scopedSlots: _vm._u(
                    [
                      !_vm.dataForTable
                        ? {
                            key: "empty",
                            fn: function() {
                              return [_vm._v("Não há registros.")]
                            },
                            proxy: true
                          }
                        : {
                            key: "empty",
                            fn: function() {
                              return [_vm._v("Não há registros.")]
                            },
                            proxy: true
                          }
                    ],
                    null,
                    true
                  )
                },
                [_vm._v(" "), _vm._t("columns")],
                2
              ),
              _vm._v(" "),
              _vm.totalElements > 0
                ? _c(
                    "div",
                    { staticClass: "pagination" },
                    [
                      _c("app-paginacao", {
                        attrs: {
                          total: _vm.totalElements,
                          pagina: _vm.pagina,
                          tamanhoPagina: 15
                        },
                        on: { changePage: _vm.alterarPagina }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38c86303", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c86303","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Tables/ListagemGenerica/ListagemGenerica.vue
// module id = null
// module chunks = 